<cmps-dialog class="h-100 cmps-cdk-pr-0dot75 cmps-cdk-mr-0dot25">
    <!-- intentionally not using background-image -->
    <div class="cmps-task-list-dialog--icaw">
        <img
            src="assets/intelligent-coach-assist-watermark.svg"
            alt=""
            aria-hidden="true"
        />
    </div>
    <cmps-dialog-header>
        <div class="cmps-task-list-dialog--header cmps-cdk-color-blue-100">
            <div>
                <img
                    class="cmps-task-list-dialog--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div>
                <cmps-icon
                    svgIcon="checkbox-marked-circle-auto-outline"
                ></cmps-icon>
            </div>
            <div
                class="cmps-cdk-ml-0dot5 cmps-cdk-flex-grow-1"
                [class.cmps-cdk-d-none]="_service.state?.searchOpen"
            >
                <div class="cmps-cdk-font-size-20p cmps-cdk-font-bold">
                    {{ _i18n._11230_MY_TASKS | translate }}
                </div>
            </div>
            <cmps-teamscall-auth
                [class.cmps-cdk-flex-grow-1]="_service.state?.searchOpen"
                [showLogin]="false"
            >
                <cmps-task-list-search-filter
                    [class.cmps-cdk-w-100pct]="_service.state?.searchOpen"
                ></cmps-task-list-search-filter>
            </cmps-teamscall-auth>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="_service.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body
        class="cmps-task-list-dialog--body cmps-cdk-d-flex cmps-cdk-flex-column"
        [attr.data-container]="_dataContainerValue"
    >
        <div
            class="cmps-cdk-flex-grow-1 cmps-cdk-overflow-y-auto cmps-cdk-overflow-x-hidden cmps-cdk-pr-0dot5"
        >
            <cmps-teamscall-auth
                [class.cmps-cdk-d-block]="authRef.hasValidToken !== true"
                [class.cmps-cdk-pt-0dot5]="authRef.hasValidToken !== true"
                [class.cmps-cdk-text-center]="authRef.hasValidToken !== true"
                (hasValidTokenChange)="_onHasValidTokenChange($event)"
                #authRef
            >
                <div
                    class="cmps-cdk-pt-0dot5"
                    *ngIf="_service.state?.pending?.reload === true"
                >
                    <cmps-wait-status></cmps-wait-status>
                </div>
                <cmps-accordion
                    [multi]="true"
                    *ngIf="_service.state?.pending?.reload !== true"
                >
                    <ng-container
                        *ngFor="let g of _service.state?.groups; let gl = last"
                    >
                        <cmps-accordion-item
                            [isOpen]="g?.open"
                            #itemRef
                        >
                            <cmps-accordion-header
                                class="cmps-cdk-bg-color-transparent"
                                [class.cmps-cdk-border-b-width-1p]="
                                    g?.tasks?.length === 0 || !itemRef._isOpen
                                "
                                [class.cmps-cdk-border-b-solid]="
                                    g?.tasks?.length === 0 || !itemRef._isOpen
                                "
                                [class.cmps-cdk-border-b-color-grey-300]="
                                    g?.tasks?.length === 0 || !itemRef._isOpen
                                "
                            >
                                <div
                                    class="cmps-cdk-font-size-15p cmps-cdk-font-bold cmps-cdk-text-center"
                                >
                                    <div>{{ g?.label | translate }}</div>
                                </div>
                            </cmps-accordion-header>
                            <cmps-accordion-content>
                                <ng-container
                                    *ngFor="let t of g?.tasks; let tl = last"
                                >
                                    <cmps-task-list-task
                                        class="cmps-cdk-border-t-width-1px cmps-cdk-border-r-width-1px cmps-cdk-border-b-width-0p cmps-cdk-border-l-width-1px cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
                                        [class.cmps-cdk-border-b-width-1p]="
                                            tl === true
                                        "
                                        [item]="t"
                                        [dataContainerValue]="
                                            _dataContainerValue
                                        "
                                    >
                                    </cmps-task-list-task>
                                </ng-container>
                            </cmps-accordion-content>
                        </cmps-accordion-item>
                    </ng-container>
                </cmps-accordion>
            </cmps-teamscall-auth>
        </div>
        <cmps-teamscall-auth [showLogin]="false">
            <div class="cmps-cdk-ml-0dot5 cmps-cdk-mr-0dot75 cmps-cdk-my-0dot5">
                <cmps-task-list-new-task
                    [dataContainerValue]="_dataContainerValue"
                ></cmps-task-list-new-task>
            </div>
        </cmps-teamscall-auth>
    </cmps-dialog-body>
</cmps-dialog>
